import React, { useEffect, useState } from 'react'
import Template from '../utils/Template'
import { ToastContainer } from 'react-toastify'
import { postMethodService } from '../services';
import { ADMIN_PASSWORD_CHANGE_API } from '../services/constants';
import { useNavigate } from 'react-router-dom';
import { HandleLogout } from '../utils/Helper';
import Input from '../utils/Input';
import SubmitBtn from '../utils/SubmitBtn';
import { useMutation } from '@tanstack/react-query';
import { stateObjType } from '../types';
const Cookies = require('js-cookie');

const ChangePassword = () => {

    const [isLoading,setIsLoading] = useState(false);
    const [oldPass,setOldPass] = useState("");
    const [newPass,setNewPass] = useState("");
    const [conPass,setConPass] = useState("");
    const [oldPasswordError,setOldPasswordError] = useState("");
    const [newPasswordError,setNewPasswordError] = useState("");
    const [conPasswordError,setConPasswordError] = useState("");
    const navigate = useNavigate();


    // const mutation = useMutation({
    //     mutationFn: (userData:stateObjType) => postMethodService(ADMIN_PASSWORD_CHANGE_API, userData, true),
    // });


    const changePassHandler = (e:React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        // setIsLoading(true);
        const userData = {
            old_password: oldPass,
            new_password: newPass,
            confirm_password: conPass
        };
        // mutation.mutate(userData);
        postMethodService(ADMIN_PASSWORD_CHANGE_API, userData, true)
        .then(res => {
            setIsLoading(false);
            if(res == 401){
                HandleLogout(navigate);
            };
            if(res?.status){
                const getToken = Cookies.get("a_u");
                const delay = setTimeout(()=>{
                    if(getToken){
                        Cookies.remove("a_u");
                        setOldPass("");
                        setNewPass("");
                        setConPass("");
                        navigate('/login');
                    };
                  },1000);
      
                  return ()=> {
                      clearTimeout(delay);
                  };
        };
        });
    };


    const oldPasswordHandler = (e:React.ChangeEvent<HTMLInputElement>) => {
        setOldPass(e.target.value);
        setOldPasswordError("");
    };

    const newPasswordHandler = (e:React.ChangeEvent<HTMLInputElement>) => {
        setNewPass(e.target.value);
        setNewPasswordError("");
    };

    const conPasswordHandler = (e:React.ChangeEvent<HTMLInputElement>) => {
        setConPass(e.target.value);
        setConPasswordError("");
    };

  return (
    <>
        <Template title='Account'>
            <div className="card mb-3 mb-lg-5">
                <div className="card-header">
                    <div className="row align-items-center">
                        <div className="col-sm-5">
                            <h4 className="card-title">
                                Change password
                            </h4>
                        </div>
                    </div>
                </div>
                <div className="card-body">
                    <div className="row">
                        <div className="col-sm-6">
                            <form onSubmit={changePassHandler}>
                                <Input title="Old password" type="password" error={oldPasswordError} tabIndex={0} placeholder="********" name="oldPassowrd" value={oldPass} event={oldPasswordHandler}/>
                                <Input title="New password" type="password" error={newPasswordError} tabIndex={1} placeholder="********" name="newPassowrd" value={newPass} event={newPasswordHandler}/>
                                <Input title="Confirm password" type="password" error={conPasswordError} tabIndex={2} placeholder="********" name="conPassowrd" value={conPass} event={conPasswordHandler}/>
                                <div className="d-grid">
                                    <SubmitBtn type="submit" isLoading={isLoading} name='Submit'/>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </Template>
        <ToastContainer />
    </>
  )
}

export default ChangePassword
